module.exports = __webpack_public_path__ + "static/media/user.6d81db68.jpeg";